export enum IntentSourceEnum {
    SALES_INTEL = 'SALES_INTEL',
    BOMBORA = 'BOMBORA',
    ALL = 'ALL',
}
